<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Cashier Shift Close") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("select") }}
                  {{ $t("date") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="usersList && usersList.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} User</label
              >
              <multiselect
                :options="usersList"
                v-model="selectedUser"
                :searchable="true"
                label="username"
                track-by="user_id"
                placeholder="Select user"
                @input="onSelectUser($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>

              <!--New Drop Down--->
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selectedScreen.screen_name"
                class="w-100"
                variant="dropdown-curve"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in usersList"
                  :key="dropdownIndex"
                  @click="onSelectUser($event)"
                  >{{ dropdownItem.screen_name }}
                </b-dropdown-item>
              
              </b-dropdown> -->
              <!--Ends--->
            </div>
          </div>
          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div> -->

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <b-form-checkbox
              :id="`checkbox-1`"
              :name="`checkbox-1`"
              value="Y"
              class="j-checkbox"
              unchecked-value="N"
              v-model="downloadAllUsers"
              @change="downloadAll($event)"
              >Select All Users
            </b-form-checkbox>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getShiftCloseList()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
          <div
            class="col-lg-6 col-xl-3 align-self-center mb-3"
            v-if="userSelectedId.length > 0"
          >
            <button
              class="btn-blue-lg w-100"
              @click.prevent="downloadMultipleFile('pdf')"
            >
              Download Reports Pdf
            </button>
          </div>
          <!-- <div
            class="col-lg-6 col-xl-3 align-self-center mb-3"
            v-if="userSelectedId.length > 0"
          >
            <button
              class="btn-blue-lg w-100"
              @click.prevent="downloadMultipleFile('excel')"
            >
              Download Reports Excel
            </button>
          </div> -->
        </div>
      </div>
      <div v-if="shiftsCloseValues.length > 0" class="table-scroll">
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th v-if="downloadAllUsers === 'N'">{{ $t("action") }}</th>
            <th>{{ $t("name") }}</th>
            <th>Employee Code</th>
            <th>{{ $t("login_date_time") }}</th>
            <th>{{ $t("logout_date_time") }}</th>
            <th>{{ $t("Float Amount") }}</th>
            <th>{{ $t("boxoffice_amount") }}</th>
            <th>{{ $tc("fnb_amount") }}</th>
            <th>{{ $t("collectionAmount") }}</th>
            <th>{{ $t("discount") }}</th>
            <th>{{ $t("systemAmount") }}</th>
            <th>{{ $t("Excess / Shortage") }}</th>
            <!-- <th>Status</th> -->
          </thead>
          <tbody>
            <template
              v-for="(shiftsList, shiftsListIndex) in shiftsCloseValues"
            >
              <tr :key="shiftsListIndex + 'shiftsClosedList'">
                <td
                  class="d-flex align-items-center mt-2 no_border"
                  v-if="downloadAllUsers === 'N'"
                >
                  <span>
                    <b-form-checkbox
                      :id="`checkbox-${shiftsListIndex}`"
                      :name="`checkbox-${shiftsListIndex}`"
                      value="Y"
                      class="j-checkbox"
                      unchecked-value="N"
                      @change="pushRevenueId(shiftsList.usl_id, $event)"
                    >
                    </b-form-checkbox
                  ></span>
                  <span
                    ><a
                      v-if="userSelectedId.length == 0"
                      target="_blank"
                      download
                      title="Download as PDF"
                      @click="getSinglePdf(shiftsList.usl_id)"
                    >
                      <img
                        src="@/assets/img/icons/pdf-icon.svg"
                        height="25"
                        width="25"
                      /> </a
                  ></span>
                  <span
                    ><a
                      v-if="userSelectedId.length == 0"
                      target="_blank"
                      download
                      title="Download as Excel"
                      @click="getSingleExcel(shiftsList.usl_id)"
                    >
                      <img
                        class="mx-1"
                        src="@/assets/img/icons/excel.svg"
                        height="25"
                        width="25" /></a
                  ></span>
                </td>
                <td class="text-left">{{ shiftsList.operator }}</td>
                <td class="text-left">
                  {{
                    shiftsList.up_employee_code
                      ? `( ${shiftsList.up_employee_code} )`
                      : ``
                  }}
                </td>
                <td class="text-left">
                  {{ shiftsList.login_date_time | fulldatemonparse }}
                </td>
                <td class="text-left">
                  {{ shiftsList.logout_date_time | fulldatemonparse }}
                </td>
                <td class="text-right">
                  {{ currFormat(shiftsList.float_amount) }}
                </td>
                <td class="text-right">
                  {{ currFormat(shiftsList.BoxOfficeAmount) }}
                </td>
                <td class="text-right">
                  {{ currFormat(shiftsList.FnbAmount || 0) }}
                </td>
                <td class="text-right">
                  {{ currFormat(shiftsList.collection_amount || 0) }}
                </td>
                <td class="text-right">
                  {{ currFormat(shiftsList.Discount || 0) }}
                </td>
                <td class="text-right">
                  {{ currFormat(shiftsList.system_amount || 0) }}
                </td>
                <td class="text-right">
                  {{
                    (
                      shiftsList.collection_amount - shiftsList.system_amount
                    ).toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <!-- <td>{{ shiftsList.shift_end }}</td> -->
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div v-if="shiftsCloseValues.length == 0" class="table-scroll">
        <table class="swc-report-table">
          <thead class="bg-lightgrey font-weight-bold">
            <th>{{ $t("action") }}</th>
            <th>{{ $t("name") }}</th>
            <th>Employee Code</th>
            <th>{{ $t("login_date_time") }}</th>
            <th>{{ $t("logout_date_time") }}</th>
            <th>{{ $t("Float Amount") }}</th>
            <th>{{ $t("boxoffice_amount") }}</th>
            <th>{{ $tc("fnb_amount") }}</th>
            <th>{{ $t("collectionAmount") }}</th>
            <th>{{ $t("discount") }}</th>
            <th>{{ $t("systemAmount") }}</th>
            <th>{{ $t("Excess / Shortage") }}</th>
          </thead>
          <tbody>
            <tr>
              <td colspan="12">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="d-flex justify-content-end mt-3 mb-1 align-items-center">
        <div class="mx-1">{{ $t("download") }} as:</div>
        <a target="_blank" download title="Download as PDF">
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>
        <a href="#" title="Download as Excel">
          <img
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </a>
      </div> -->
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      usersList: [],
      selectedUser: { user_id: null, username: "" },
      revenueReportData: [],
      userSelectedId: [],
      shiftsCloseValues: [],
      checkBoxValue: false,
      downloadAllUsers: "N",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.getSingleDayClosedUsers();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
    fromDate: function (val) {
      this.getSingleDayClosedUsers();
      this.selectedUser = { user_id: null, username: "" };
      return;
    },
    userSelectedId: function (val) {
      this.userSelectedId = val;
    },
  },
  mounted() {},
  methods: {
    moment,
    downloadAll(event) {
      if (event == "Y") {
        this.shiftsCloseValues.map((x) => {
          if (!this.userSelectedId.includes(x.usl_id)) {
            this.userSelectedId.push(x.usl_id);
          }
        });
      } else {
        this.userSelectedId = [];
      }
    },
    pushRevenueId(shiftId, event) {
      console.log(event);
      if (event == "Y") {
        return this.userSelectedId.push(shiftId);
      }
      // if (event == false) {
      let spliceIndex = this.userSelectedId.indexOf(shiftId);
      console.log(spliceIndex);
      spliceIndex >= 0
        ? this.userSelectedId.splice(spliceIndex, 1)
        : this.userSelectedId;
      console.log(this.userSelectedId);
      // }
    },
    downloadMultipleFile(type) {
      type == "pdf"
        ? this.getRevenueDropReport()
        : this.getRevenueDropReportExcel();
    },
    getSinglePdf(usl_id) {
      let loader = this.$loading.show();
      let payload = {
        shift_id: [usl_id],
         cinema_id: this.dropDown.selectedCinemaId,
      };
      MasterService.GetRdrPdfReport(payload)
        .then((result) => {
          const { data } = result;
          window.open(data.tempFile);
          loader.hide();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSingleExcel(usl_id) {
      let loader = this.$loading.show();
      let payload = {
        shift_id: [usl_id],
        cinema_id: this.dropDown.selectedCinemaId,

      };
      MasterService.GetRdrExcelReport(payload)
        .then((result) => {
          const { data } = result;
          window.open(data.exlPath);
          loader.hide();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSelectUser(eventData) {
      this.selectedUser = eventData;
      this.shiftsCloseValues = [];
      this.getShiftCloseList().then((response) => {
        this.shiftsCloseValues = this.shiftsCloseValues.filter((x) => {
          return x.user_id == eventData.user_id;
        });
      });
    },
    getShiftCloseList() {
      // const { changeDate } = params;

      if (this.endDate && !this.startDate) {
        this.$toasted.show("Please select start date");
        return;
      }
      if (!this.dropDown.selectedCinemaId) {
        this.$toasted.show("Please select Cinema");
        return;
      }

      this.shiftsCloseValues = [];
      let loader = this.$loading.show();
      let payload = {
        currentPage: 1,
        limit: 100000,
        searchValue: null,
        startDate: moment(this.fromDate).format("YYYY-MM-DD"),
        endDate: moment(this.fromDate).add(1, "days").format("YYYY-MM-DD"),
        cinema_id: this.dropDown.selectedCinemaId,
        shiftStatus: "Closed",
      };
      CinemasService.GetShiftClose(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              // if (data.PdfPath) {
              //   this.PdfPath = data.PdfPath;
              // }

              this.shiftsCloseValues = data.Records.filter((x) => {
                let findUserIndex = this.usersList.findIndex((userIndex) => {
                  return userIndex.user_id == x.user_id;
                });
                if (findUserIndex < 0) {
                  this.usersList.push({
                    user_id: x.user_id,
                    username: x.operator,
                  });
                }
                if (this.selectedUser.user_id != null) {
                  return (
                    x.shift_end == "Y" && x.user_id == this.selectedUser.user_id
                  );
                } else {
                  return x.shift_end == "Y";
                }
              });
              loader.hide();
              // if (data.hasOwnProperty("paginationData")) {
              //   if (data.paginationData.hasOwnProperty("total")) {
              //     if (data.paginationData.total >= 10) {
              //       this.rows = data.paginationData.total;
              //     } else {
              //       this.rows = data.paginationData.total;
              //       this.selectedvalue = data.paginationData.total;
              //     }
              //   }
              // }
              // if (data.totalRows >= 10) {
              //   this.rows = data.totalRows;
              // } else {
              //   this.rows = data.totalRows;
              //   this.selectedvalue = data.totalRows;
              // }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 2000);
        }); //message
    },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getSingleDayClosedUsers() {
      let payload = {
        cinema_id:
          this.dropDown.selectedCinemaId || this.dropDown.cinemas[0].cine_id,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.fromDate).add(1, "days").format("YYYY-MM-DD"),
      };
      ReportsService.GetClosedShiftSingleDay(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.usersList = data.Records;
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRevenueDropReport() {
      let loader = this.$loading.show();
      let payload = {
        shift_id: this.userSelectedId ? this.userSelectedId : [],
      };

      MasterService.GetRdrPdfReport(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.tempFile) {
              window.open(data.tempFile);
              loader.hide();
            } else {
              this.$toasted.show("Pdf not generated");
            }
          } else {
            this.$$toasted.show("Something went wrong");
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
    getRevenueDropReportExcel() {
      let loader = this.$loading.show();
      let payload = {
        shift_id: this.userSelectedId ? this.userSelectedId : [],
      };
      MasterService.GetRdrExcelReport(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.exlPath) {
              window.open(data.exlPath);
              loader.hide();
            } else {
              this.$toasted.show("Pdf not generated");
            }
          } else {
            this.$$toasted.show("Something went wrong");
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/revenueDropReport.vue